module.exports = __webpack_public_path__ + "static/media/4ODA16.9e82ae6d.jpg";